import { AbstractPmsApiService } from './abstract.service'
import { Role } from "../models";

/**
 * @class RolePmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<Role>}
 */
export class RolePmsApiService extends AbstractPmsApiService {
    
    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {
        
        return '/property/:propertyId/role(/:id)'
    }
    
    /**
     * @param {Object.<string, *>} attributes
     * @returns {Role}
     * @protected
     */
    newModel(attributes, ...params) {
        
        return new Role(attributes);
    }
    
    /**
     * @param {Object=} params
     * @param {Property=} property
     * @returns {Promise.<PaginationCollection<Role>>}
     */
    get(params = {}, property = {}) {
        
        const url = this.url({propertyId: property.id ? property.id : 0});
        
        return this.http
                   .get(url, {
                       headers: this.authHeaders,
                       params,
                   })
                   .then(this.getPaginationCollector())
                   .catch(this.getErrorHandler());
    }
    
    /**
     * @param {Role} role
     * @param {Property} property
     * @returns {Promise.<Role>}
     */
    create(role, property) {
        
        const url = this.url({propertyId: property.id});
        
        return this.http
                   .post(url, role.toObjectExcept('property'), {
                       headers: this.authHeaders
                   })
                   .then(this.getModeler())
                   .catch(this.getErrorHandler());
    }
    
    /**
     * @param {Role} role
     * @returns {Promise.<Role>}
     */
    update(role) {
        
        const url = this.url({
            propertyId: role.property.id,
            id:         role.id
        });
        
        return this.http
                   .put(url, role.toObjectExcept('property'), {
                       headers: this.authHeaders
                   })
                   .then(this.getModeler())
                   .catch(this.getErrorHandler());
    }
    
    /**
     * @param {Role} role
     * @returns {Promise.<boolean>}
     */
    delete(role) {
        
        const url = this.url({
            propertyId: role.property.id,
            id:         role.id
        });
        
        return this.http
                   .delete(url, {
                       headers: this.authHeaders
                   })
                   .then(this.getStatusExtractor())
                   .catch(this.getErrorHandler());
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/role.service.js